// src/styles/theme.js
// Sistema de temas centralizado para toda la aplicación

export const theme = {
  // Colores principales
  colors: {
    primary: '#383838',      // Gris oscuro principal
    secondary: '#000000',    // Negro
    accent: '#1a1a1a',       // Negro suave
    light: '#f5f5f5',        // Gris muy claro
    white: '#ffffff',        // Blanco puro
    
    // Grises
    gray: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#e5e5e5',
      300: '#d4d4d4',
      400: '#a3a3a3',
      500: '#737373',
      600: '#525252',
      700: '#404040',
      800: '#262626',
      900: '#171717',
    },
    
    // Estados
    success: {
      light: '#d4edda',
      main: '#28a745',
      dark: '#1e7e34',
    },
    error: {
      light: '#f8d7da',
      main: '#dc3545',
      dark: '#bd2130',
    },
    warning: {
      light: '#fff3cd',
      main: '#ffc107',
      dark: '#e0a800',
    },
    info: {
      light: '#d1ecf1',
      main: '#17a2b8',
      dark: '#138496',
    },
  },
  
  // Clases de Tailwind CSS personalizadas
  classes: {
    // Sidebar
    sidebar: {
      container: 'bg-gradient-to-b from-[#000000] to-[#383838] shadow-2xl',
      border: 'border-gray-700',
      header: 'border-gray-700',
      button: {
        active: 'bg-white text-[#383838] shadow-lg transform scale-105',
        inactive: 'text-gray-300 hover:bg-gray-800 hover:text-white',
      },
      userCard: 'bg-gray-900 bg-opacity-50 rounded-xl backdrop-blur-sm border border-gray-700',
      logout: 'text-white hover:bg-red-600',
    },
    
    // Header
    header: {
      container: 'bg-white shadow-md border-b border-gray-200',
      title: 'text-3xl font-bold bg-gradient-to-r from-[#383838] to-[#000000] bg-clip-text text-transparent',
      subtitle: 'text-gray-600',
    },
    
    // Backgrounds
    background: {
      main: 'bg-gray-50',
      card: 'bg-white',
      hover: 'hover:bg-gray-50',
    },
    
    // Botones
    button: {
      primary: 'bg-gradient-to-r from-[#383838] to-[#000000] hover:from-[#000000] hover:to-[#383838] text-white shadow-lg hover:shadow-xl',
      secondary: 'border-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400',
      danger: 'bg-red-600 hover:bg-red-700 text-white',
      success: 'bg-green-600 hover:bg-green-700 text-white',
    },
    
    // Cards
    card: {
      base: 'bg-white rounded-xl shadow-sm border border-gray-200',
      hover: 'hover:shadow-md transition-shadow duration-200',
      gradient: 'bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-200 hover:border-gray-400',
    },
    
    // Tablas
    table: {
      header: 'bg-gradient-to-r from-[#383838] to-[#000000] text-white',
      row: 'hover:bg-gray-50 transition-colors duration-150',
      cell: 'px-6 py-4',
    },
    
    // Forms
    form: {
      input: 'w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#383838] focus:border-transparent hover:border-gray-300',
      inputError: 'border-red-300 bg-red-50',
      label: 'block text-sm font-semibold text-gray-700',
      select: 'w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#383838] focus:border-transparent hover:border-gray-300 appearance-none bg-white',
    },
    
    // Estados
    status: {
      online: 'bg-gradient-to-r from-green-400 to-emerald-500 text-white border-2 border-green-300',
      offline: 'bg-gradient-to-r from-gray-400 to-gray-500 text-white border-2 border-gray-300',
      active: 'bg-green-100 text-green-800 border border-green-200',
      inactive: 'bg-gray-100 text-gray-800 border border-gray-200',
    },
    
    // Badges
    badge: {
      primary: 'bg-gray-100 text-gray-800 border border-gray-200',
      success: 'bg-green-100 text-green-800 border border-green-200',
      danger: 'bg-red-100 text-red-800 border border-red-200',
      warning: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
      info: 'bg-blue-100 text-blue-800 border border-blue-200',
    },
    
    // Iconos decorativos
    iconBox: {
      primary: 'w-12 h-12 rounded-lg bg-[#383838] flex items-center justify-center',
      success: 'p-2 bg-green-100 rounded-lg',
      danger: 'p-2 bg-red-100 rounded-lg',
      warning: 'p-2 bg-yellow-100 rounded-lg',
      info: 'p-2 bg-blue-100 rounded-lg',
    },
  },
  
  // Transiciones y animaciones
  transitions: {
    default: 'transition-all duration-200',
    slow: 'transition-all duration-300',
    fast: 'transition-all duration-150',
  },
  
  // Sombras
  shadows: {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl',
    '2xl': 'shadow-2xl',
  },
};

// Función helper para combinar clases
export const cn = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

// Exportar como default también
export default theme;